import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function RealtimeTracking() {
  const trackingArticles = articles.slice(6, 10);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
            24H 实时追踪
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">最新爆料，分秒必达</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {trackingArticles.map((article, i) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block relative"
            >
              <div className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300 group-hover:translate-y-[-4px]">
                {i === 0 && (
                  <div className="absolute top-3 left-3 z-10 px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    独家
                  </div>
                )}
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={article.trackImageUrl}
                    alt={article.title}
                    title={`911爆料网 - ${article.title}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="mt-3 px-1">
                <h4 className="font-heading font-bold text-foreground-900 text-sm md:text-base leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h4>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}